import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { ValidateButtonComponent } from '../../buttons/validate-button.component';
import { SecondaryButtonComponent } from '../../buttons/secondary-button.component';

@Component({
  selector: 'sibat-dialog-confirmation',
  template: `
    <mat-dialog-content>
      {{ data.message }}
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <sibat-validate-button class="mat-button-base" [mat-dialog-close]="true" [label]="data.acceptLabel"></sibat-validate-button>
      <sibat-secondary-button class="mat-button-base" [mat-dialog-close]="false" [label]="data.cancelLabel"></sibat-secondary-button>
    </mat-dialog-actions>
  `,
  imports: [CdkScrollable, MatDialogContent, MatDialogActions, ValidateButtonComponent, MatDialogClose, SecondaryButtonComponent],
})
export class DialogConfirmationComponent {
  constructor(
    public dialogRef: MatDialogRef<DialogConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { message: string; acceptLabel: string; cancelLabel: string }
  ) {}
}
